import React, { ReactNode } from "react";
import { Navigate } from "react-router";
import { platformErrorsAccess } from "@/features/observability/platform-errors/access/platform-errors-access";

// A build without the flag has no such screen; with it, the page shows whatever the backend answers (403 included).
export const PlatformErrorsRoute: React.FC<{ children: ReactNode }> = ({ children }) =>
    platformErrorsAccess.featureEnabled() ? <>{children}</> : <Navigate to="/command-center" replace />;
